import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import TvChannelLayer from "../../components/TvChannel/TvChannelLayer";

const TvChannelPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="TV Channel Management" />
      <TvChannelLayer />
    </MasterLayout>
  );
};

export default TvChannelPage;
